import { DOCUMENT, isPlatformServer } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { ActivatedRouteSnapshot, UrlTree } from '@angular/router';
import { GalleryDto } from '@picflow/types';
import { addIdPrefix } from 'src/app/lib/add-id-prefix';
import { getAllRouteParams } from 'src/app/lib/get-all-route-params';
import { getPermissions } from 'src/app/lib/get-allowed-feedback-options';
import { getFullPath } from 'src/app/lib/get-full-path';
import { disableBodyScroll } from 'src/app/lib/toggle-body-scroll';
import { AssetService } from 'src/app/services/asset.service';
import { GalleryService } from 'src/app/services/gallery.service';
import { RedirectService } from 'src/app/services/redirect.service';

@Injectable({
  providedIn: 'root',
})
export class AssetVersionGuard {
  constructor(
    private assetService: AssetService,
    @Inject(PLATFORM_ID) private platformId: Object,
    @Inject(DOCUMENT) private document: Document,
    private redirectService: RedirectService,
    private galleryService: GalleryService
  ) {}

  async canActivate(next: ActivatedRouteSnapshot): Promise<UrlTree | boolean> {
    if (isPlatformServer(this.platformId)) return true;
    const params = getAllRouteParams(next);
    const path = getFullPath(next);

    let gallery: GalleryDto;

    let allowHistory: boolean;
    if (params.galleryId) {
      gallery = await this.galleryService.getGallery(addIdPrefix(params.galleryId, 'gal'));
      if (!gallery) return false;
      allowHistory = gallery.version_history_enabled;
    } else {
      gallery = await this.galleryService.getPublicGalleryFromSnapshot(next, { isPublic: path[0] !== 'a' });
      if (!gallery) return false;
      const permissions = getPermissions(gallery);
      allowHistory = permissions.gallery.clientAdvancedMode && gallery.version_history_enabled;
    }

    if (path[0] === 'a' || allowHistory) {
      const assetId = next.params.assetId.replace('}', '');
      const versions = await this.assetService.getAssetVersions(assetId, gallery.id);

      const version = versions.find(v => v.id === next.params.versionId);
      if (version) {
        disableBodyScroll('asset-page');
        // this.document.body.classList.add('noscroll-asset-page');
        return true;
      }
    }

    const route = getFullPath(next);

    return this.redirectService.redirectTo(
      route.slice(
        0,
        route.findIndex(p => p === 'version')
      )
    );
  }
}
